<p class="text-center text-sm leading-6 text-gray-500">
  {{ text }}
  <a (click)="linkedClicked()" class="font-semibold text-cool-blue hover:underline cursor-pointer">{{ linktext }}</a>
</p>
